// 统计创建订单的上级页面来源
export enum ORDERFORMENUM {
  NG_CART = "NG_CART", // 内购购物车"
  CART = "CART", //"购物车"
  GOOD_DETAIL = "GOOD_DETAIL", // "商品详情页"
  SCENE_SHOPPING_LIST ="SCENE_SHOPPING_LIST", //"场景购物清单"
  MD_PACKAGE_DETAIL = 'MD_PACKAGE_DETAIL', //场景成套方案详情
  SCENE_LIGHT_DESIGN = 'SCENE_LIGHT_DESIGN', // 快下单方案页
}
